var React = require('react');

function Cloud (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M143 41.0002H0L0.734086 38.4656C4.11088 26.9856 17.9117 25.3456 21.5821 25.1965C34.3552 9.98926 51.9733 15.6547 57.5524 18.1893C60.3419 12.9711 69.885 -1.19256 91.614 0.000171766C113.637 1.34199 119.216 18.6365 120.39 24.8984C132.723 22.662 139.917 32.502 142.119 38.4656L143 41.0002ZM5.43224 37.1238H137.274C135.072 33.0984 129.493 26.2402 119.509 29.0729L117.16 29.8184L117.013 27.4329C116.867 26.5384 114.811 5.36744 91.614 4.02563C68.1232 2.68381 60.7823 20.7238 60.4887 21.6184L59.7546 23.7056L57.846 22.662C56.9651 22.2147 37.5852 11.7784 24.2248 28.6256L23.4908 29.222H22.6099C22.3162 29.222 9.98357 29.3711 5.43224 37.1238Z","fill":"#E0ECF4"}));
}

Cloud.defaultProps = {"width":"143","height":"41","viewBox":"0 0 143 41","fill":"none"};

module.exports = Cloud;

Cloud.default = Cloud;
